import CreateInteractionCommand from "./CreateInteractionCommand";
import InteractionEditing from "./InteractionEditing";
import InteractionUI from "./InteractionUI";

import "./interaction.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class Interaction extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "Interaction";
  }

  static get requires() {
    return [CreateInteractionCommand, InteractionEditing, InteractionUI];
  }
}
